export default function LocationMap() {
  return (
    <section className="py-24 bg-zinc-950">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-amber-500 text-sm font-semibold tracking-widest uppercase mb-3">Find Us</p>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">Our Location</h2>
          <div className="w-20 h-1 bg-amber-500 mx-auto mb-6"></div>
          <p className="text-white/60 text-base max-w-xl mx-auto">
            Located in the heart of Benin City — come experience the night of your life.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch">
          {/* Address Details */}
          <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-10 flex flex-col justify-between">
            <div>
              <h3 className="text-white text-2xl font-bold mb-8">King Square Club</h3>

              <div className="space-y-7">
                <div className="flex items-start space-x-5">
                  <div className="w-12 h-12 flex items-center justify-center bg-amber-500/10 rounded-xl shrink-0">
                    <i className="ri-map-pin-2-line text-amber-500 text-2xl"></i>
                  </div>
                  <div>
                    <p className="text-white font-semibold text-sm mb-1">Address</p>
                    <p className="text-white/60 text-sm leading-relaxed">
                      148 Airport Rd, Benin City 300102, Edo State, Nigeria
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-5">
                  <div className="w-12 h-12 flex items-center justify-center bg-amber-500/10 rounded-xl shrink-0">
                    <i className="ri-time-line text-amber-500 text-2xl"></i>
                  </div>
                  <div>
                    <p className="text-white font-semibold text-sm mb-1">Opening Hours</p>
                    <p className="text-white/60 text-sm">Friday – Sunday: 11PM – 5AM</p>
                    <p className="text-white/40 text-sm">Monday – Thursday: Closed</p>
                  </div>
                </div>

                <div className="flex items-start space-x-5">
                  <div className="w-12 h-12 flex items-center justify-center bg-amber-500/10 rounded-xl shrink-0">
                    <i className="ri-phone-line text-amber-500 text-2xl"></i>
                  </div>
                  <div>
                    <p className="text-white font-semibold text-sm mb-1">Call Us</p>
                    <a href="tel:09039844951" className="text-white/60 text-sm hover:text-amber-400 transition-colors cursor-pointer">
                      09039844951
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-5">
                  <div className="w-12 h-12 flex items-center justify-center bg-amber-500/10 rounded-xl shrink-0">
                    <i className="ri-whatsapp-line text-amber-500 text-2xl"></i>
                  </div>
                  <div>
                    <p className="text-white font-semibold text-sm mb-1">WhatsApp</p>
                    <a
                      href="https://wa.me/2349039844951"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white/60 text-sm hover:text-amber-400 transition-colors cursor-pointer"
                    >
                      09039844951
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-10 flex space-x-4">
              <a
                href="https://www.instagram.com/kingsquareclub"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 flex items-center justify-center bg-zinc-800 hover:bg-amber-500 rounded-full text-white hover:text-black transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://www.snapchat.com/add/kingsquareclub"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 flex items-center justify-center bg-zinc-800 hover:bg-amber-500 rounded-full text-white hover:text-black transition-all duration-300 cursor-pointer"
              >
                <i className="ri-snapchat-line text-lg"></i>
              </a>
              <a
                href="https://www.tiktok.com/@kingsquareclub"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 flex items-center justify-center bg-zinc-800 hover:bg-amber-500 rounded-full text-white hover:text-black transition-all duration-300 cursor-pointer"
              >
                <i className="ri-tiktok-line text-lg"></i>
              </a>
              <a
                href="https://wa.me/2349039844951"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 flex items-center justify-center bg-zinc-800 hover:bg-amber-500 rounded-full text-white hover:text-black transition-all duration-300 cursor-pointer"
              >
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Google Map */}
          <div className="rounded-2xl overflow-hidden border border-zinc-800 min-h-[480px]">
            <iframe
              title="King Square Club Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3964.0!2d5.6037!3d6.3350!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1040d3b0e1234567%3A0xabcdef1234567890!2s148+Airport+Rd%2C+Benin+City+300102%2C+Edo!5e0!3m2!1sen!2sng!4v1700000000000!5m2!1sen!2sng"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '480px' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
